<div class="content-wrapper">

  <div class="title-container">
    <div class="title">{{title}}</div>

    <button class="icon-button" (click)="onClose()">
      <tun-close-v5 class="icon icon-large-scaled-svg-button"></tun-close-v5>
    </button>

  </div>

  <tun-add-song-to-playlist
    [tracks]="tracks"
    showAddToQueue="true"
    class="contentContainer">

  </tun-add-song-to-playlist>







</div>
